module.exports = __webpack_public_path__ + "static/media/ic-3.c67403dd.svg";